module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.cf8917d3.png";